import { toast } from "react-toastify";
import { deleteData, getData,  postData, postDataSimple } from "../../utils/serverHelper"
import { CHANGE_PASSWORD, LOGIN, LOGIN_GOOGLE, REGISTER, REGISTER_VERIFY, REGISTER_VERIFY_OTP, RESET_PASSWORD, VERIFY } from "../../utils/urls"
import { failedAuth, failedOtpAuth, failedSendAuth, loadingAuth, loadingOtpAuth, loadingSendAuth, logOutAuth, successAuth, successOtpAuth, successSendAuth } from "./reducer";
import { signOutGoogle } from "../../utils/firebase.utils";
import { successDashboard } from "../business/reducer";
import { errorMessage, successMessage } from "../error/action";

export const verifyUser = async (dispatch) => {
    try {
        console.log('here verify');
        dispatch(loadingAuth());
        const data = await getData(VERIFY);
        console.log('here here verify', data?.data);
        dispatch(successAuth(data?.data));
    } catch (error) {
        console.log(error, 'log here verify');
        dispatch(failedAuth({ message: error.response?.data?.error?.message || error?.message }));
    }
}

export const login = async (dispatch, req,type,nav) => {
    // console.log(req);
    // req = { ...req}
    try {
        dispatch(loadingAuth());
        const data = await postData(LOGIN, {...req,fcm:'fcm',type});
        console.log(data.data?.token);
        if(data.data?.user?.verified === 0){
            // alert(data.data?.user?.verified)
            nav('/admin/verify?email='+req.email+'&verifyOnly=true');
        }else if(data.data?.user?.name === '' || data.data?.user?.name == null  || data.data?.user?.owner === '' || data.data?.user?.owner == null  || data.data?.user?.contact === '' || data.data?.user?.contact == null  || data.data?.user?.address === '' || data.data?.user?.address == null  ){
            
            nav('/admin/complete-setup');
            
        }else{
            // alert(data.data?.user?.verified+'no')
            nav('/admin/')
        }
        await new Promise((resolve,reject)=>{
            setTimeout(()=>resolve(true),300)
        });
        dispatch(successDashboard({}));
        localStorage.setItem('token',data.data?.token);
        localStorage.setItem('user',JSON.stringify(data.data?.user));

        dispatch(successAuth(data.data));
    } catch (error) {
        errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down. Please try again later');
        dispatch(failedAuth({ message: error.response?.data?.error?.message || error?.message }));
        // toast.error((error.response?.data?.error?.message || error?.message) || 'Something went wrong', {
        //     position: toast.POSITION.TOP_RIGHT,
        //   });
    }
}

export const loginAdmin = async (dispatch, req,type,nav) => {
    console.log(req);
    // req = { ...req}
    try {
        dispatch(loadingAuth());
        const data = await postData(LOGIN, {...req,fcm:'fcm',type:'admin'});
        console.log(data.data?.token);

        if (data.data?.user?.role === 'super_admin' && nav) {
            nav('/admin/');
        }

        dispatch(successDashboard({}));
        localStorage.setItem('token',data.data?.token);
        localStorage.setItem('user',JSON.stringify(data.data?.user));

        dispatch(successAuth(data.data));
    } catch (error) {
        errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down. Please try again later');
        dispatch(failedAuth({ message: error.response?.data?.error?.message || error?.message }));
        // toast.error((error.response?.data?.error?.message || error?.message) || 'Something went wrong', {
        //     position: toast.POSITION.TOP_RIGHT,
        //   });
    }
}

export const loginGoogle = async (dispatch, req,nav) => {
    console.log(req);
    // req = { ...req}
    try {
        dispatch(loadingAuth());
        const data = await postData(LOGIN_GOOGLE, req);
        console.log(data.data?.token);
        if(data.data?.user?.name === '' || data.data?.user?.name == null  || data.data?.user?.owner === '' || data.data?.user?.owner == null  || data.data?.user?.contact === '' || data.data?.user?.contact == null  || data.data?.user?.address === '' || data.data?.user?.address == null  ){
            nav('/admin/complete-google');
        }else{
            nav('/admin/')
        }
        await new Promise((resolve,reject)=>{
            setTimeout(()=>resolve(true),300)
        });
        localStorage.setItem('token',data.data?.token);
        localStorage.setItem('user',JSON.stringify(data.data?.user));
        dispatch(successDashboard({}));
        dispatch(successAuth(data.data));
    } catch (error) {
        errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down. Please try again later');
        dispatch(failedAuth({ message: error.response?.data?.error?.message || error?.message }));
        // toast.error((error.response?.data?.error?.message || error?.message) || 'Something went wrong', {
        //     position: toast.POSITION.TOP_RIGHT,
        //   });
    }
}

export const register = async (dispatch, req,nav) => {
    console.log(req);
    // req = { ...req}
    const {passwordConfirm,...rest} = req;

    try {
        dispatch(loadingAuth());
        const data = await postDataSimple(REGISTER, {...rest,fcm:'fcm'});
        console.log(data.data?.token);
        dispatch(successAuth(data.data));
        nav('/admin/verify?email='+rest.email+'&verifyOnly=true');
        await verifyEmail(dispatch,rest.email);
        localStorage.setItem('token',data.data?.token);
        localStorage.setItem('user',JSON.stringify(data.data?.user));
        dispatch(successDashboard({}));
    } catch (error) {
        errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down. Please try again later');
        dispatch(failedAuth({ message: error.response?.data?.error?.message || error?.message }));
        // toast.error((error.response?.data?.error?.message || error?.message) || 'Something went wrong', {
        //     position: toast.POSITION.TOP_RIGHT,
        //   });
    }
}

export const registerWeb = async (dispatch, req,nav) => {
    console.log(req);
    // req = { ...req}
    // email:'',
    // name:'',
    // password:'',
    // // passwordConfirm:'',
    // // number:'',
    // // address:'',
    // // owner:'',
    // business_type:0,
    const {passwordConfirm,number,owner,address,...rest} = req;

    try {
        dispatch(loadingAuth());
        const data = await postDataSimple(REGISTER+'/web', {...rest,fcm:'fcm'});
        console.log(data.data?.token);
        dispatch(successAuth(data.data));
        nav('/admin/verify?email='+rest.email+'&verifyOnly=true');
        await verifyEmail(dispatch,rest.email);
        localStorage.setItem('token',data.data?.token);
        localStorage.setItem('user',JSON.stringify(data.data?.user));
        dispatch(successDashboard({}));

    } catch (error) {
        errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down. Please try again later');
        dispatch(failedAuth({ message: error.response?.data?.error?.message || error?.message }));
        // toast.error((error.response?.data?.error?.message || error?.message) || 'Something went wrong', {
        //     position: toast.POSITION.TOP_RIGHT,
        //   });
    }
}

export const registerWebGoogle = async (dispatch, req,nav) => {
    console.log(req);
    // req = { ...req}
    // email:'',
    // name:'',
    // password:'',
    // // passwordConfirm:'',
    // // number:'',
    // // address:'',
    // // owner:'',
    // business_type:0,
    // const {passwordConfirm,number,owner,address,...rest} = req;



    try {
        dispatch(loadingAuth());
        const data = await postDataSimple(REGISTER+'/google-auth', req);
        console.log(data.data?.token);
        dispatch(successAuth(data.data));

        nav('/admin/complete-google');
        // await verifyEmail(dispatch,req.email);
        localStorage.setItem('token',data.data?.token);
        localStorage.setItem('user',JSON.stringify(data.data?.user));
        dispatch(successDashboard({}));

    } catch (error) {
        errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down. Please try again later');
        dispatch(failedAuth({ message: error.response?.data?.error?.message || error?.message }));
        // toast.error((error.response?.data?.error?.message || error?.message) || 'Something went wrong', {
        //     position: toast.POSITION.TOP_RIGHT,
        //   });
    }
}

export const logOut = async(dispatch)=>{
    try {
        await signOutGoogle();
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        dispatch(logOutAuth());
    } catch (error) {
        console.log(error);
    }
}

export const deleteAccount = async(dispatch,id)=>{
    try {
        await deleteData(`/admin/business/${id}/delete`);
        await signOutGoogle();
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        dispatch(logOutAuth());
        successMessage(dispatch,'Account deleted successfully');
    } catch (error) {
        errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down. Please try again later');
        console.log(error);
    }
}

export const verifyEmail = async (dispatch, email) => {
    try {
        dispatch(loadingSendAuth());
         await postDataSimple(REGISTER_VERIFY, {email});
         dispatch(successSendAuth());
         toast.success('Email has been sent to your emailId');
         return true;
    } catch (error) {
        // errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down. Please try again later');

        dispatch(failedSendAuth({ message: error.response?.data?.error?.message || 'Something went wrong' }));
        return error.response?.data?.error?.message || 'Something went wrong' 
    }
}

export const verifyEmailOtp = async (dispatch, email,otp,nav) => {
    try {
        dispatch(loadingOtpAuth());
        const data = await postDataSimple(REGISTER_VERIFY_OTP, {email,otp});
        // console.log(data.data?.token);
        // localStorage.setItem('token',data.data?.token);
        const verifiedUser = Array.isArray(data?.data) ? data.data[0] : data?.data;
        localStorage.setItem('user',JSON.stringify(verifiedUser));
        dispatch(successOtpAuth(verifiedUser));
        dispatch(successDashboard({}));
        if(nav){
            nav();
        }
    } catch (error) {
        errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down. Please try again later');

        dispatch(failedOtpAuth({ message: error.response?.data?.error?.message || error?.message }));
        // toast.error((error.response?.data?.error?.message || error?.message) || 'Something went wrong', {
        //     position: toast.POSITION.TOP_RIGHT,
        //   });
    }
}

export const resetPassword = async (dispatch, password,email,nav) => {
    try {
        dispatch(loadingOtpAuth());
        const data = await postDataSimple(RESET_PASSWORD, {email,password});
        // console.log(data.data?.token);
        // localStorage.setItem('token',data.data?.token);
        // localStorage.setItem('user',JSON.stringify(data.data));
        // dispatch(logOutAuth());
        console.log(data.data,'reset');
        dispatch(successDashboard({}));
        await login(dispatch,{email,password},data?.data || 'business',nav);

        // nav('/admin/login');
    } catch (error) {
        errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down. Please try again later');

        dispatch(failedOtpAuth({ message: error.response?.data?.error?.message || error?.message }));
        // toast.error((error.response?.data?.error?.message || error?.message) || 'Something went wrong', {
        //     position: toast.POSITION.TOP_RIGHT,
        //   });
    }
}
export const changePassword = async (dispatch,passwordCurrent,password) => {
    console.log(passwordCurrent,password);
    try {
        dispatch(loadingOtpAuth());
        const data = {
            passwordCurrent,
            password
        };
        await postData(CHANGE_PASSWORD,data);
        // console.log(email);
        // console.log(data.data,'reset');
        // dispatch(successDashboard({}));
        // await login(dispatch,{passwordCurrent,password},data?.data || 'business');

        successMessage(dispatch,'Password changed successfully');
        // nav('/admin/login');
    } catch (error) {
        errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down. Please try again later');

        dispatch(failedOtpAuth({ message: error.response?.data?.error?.message || error?.message }));
        // toast.error((error.response?.data?.error?.message || error?.message) || 'Something went wrong', {
        //     position: toast.POSITION.TOP_RIGHT,
        //   });
    }
}

// export const verifyToken = async (dispatch, req) => {
//     console.log(req);
//     // req = { ...req}
//     try {
//         dispatch(loadingAuth());
//         const data = await postData(LOGIN, req);
//         console.log(data.data?.token);
//         dispatch(successAuth(data.data));
//     } catch (error) {
//         dispatch(failedAuth({ message: error.response?.data?.error?.message || error?.message }));
//         toast.error((error.response?.data?.error?.message || error?.message) || 'Something went wrong', {
//             position: toast.POSITION.TOP_RIGHT,
//           });
//     }
// }
